const ObjectFunc = require('@/tbs/util/ObjectFunc')

/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_MatchEvent = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_MatchEvent.prototype = {
    /* The view object name */
    name: 'event',
    /* The view object instance */
    view: {
        query: {
            baseUrl: process.env.VUE_APP_PASS_API,
            apiPrefix: '/api/',
            service: 'GetBMStageGamesByBMMatchId.json',
            basePath: 'data.games',
            rule: {
                id: 'id',
                seq: '$index',
                status: '$state',
                roundSeq: '$round',
                startDateTime: '$beginDate',
                homeTeamId: 'homeTeamId',
                awayTeamId: 'awayTeamId',
                homeTeamName: 'homeTeamName',
                awayTeamName: 'awayTeamName',
                homeTeamLogoUrl: 'homeTeamBadge',
                awayTeamLogoUrl: 'awayTeamBadge',
                homeTeamScore: '$homeScore,homePenalty',
                awayTeamScore: '$awayScore,awayPenalty',
                homeTeamPenaltyScore: '$homePenalty',
                awayTeamPenaltyScore: '$awayPenalty',
                groupName: 'groupName',
            }
        }
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderStatus: function(state) {
        return (state + 1).toString()
    },
    renderSeq: function(index) {
        return ObjectFunc.pad(index, 3)
    },
    renderRoundSeq: function(round) {
        return round.toString()
    },
    renderHomeTeamPenaltyScore: function(homePenalty) {
        if (homePenalty == -1) {
            return ''
        }
        else {
            return homePenalty.toString()
        }
    },
    renderAwayTeamPenaltyScore: function(awayPenalty) {
        if (awayPenalty == -1) {
            return ''
        }
        else {
            return awayPenalty.toString()
        }
    },
    renderHomeTeamScore: function(homeScore, homePenalty) {
        if (homeScore == -1) {
            return ''
        }
        else {
            if (homePenalty == -1) {
                return homeScore.toString()
            }
            else {
                return (homeScore - homePenalty).toString()
            }
        }
    },
    renderAwayTeamScore: function(homeScore, homePenalty) {
        if (homeScore == -1) {
            return ''
        }
        else {
            if (homePenalty == -1) {
                return homeScore.toString()
            }
            else {
                return (homeScore - homePenalty).toString()
            }
        }
    },
    renderStartDateTime: function(beginDate) {
        return new Date(beginDate)
    }
}

module.exports = tbs_model_vo_MatchEvent